import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ILogger } from 'bi-interfaces';

@Injectable({
    providedIn: "root"
})
export class LoggerService implements ILogger {
    Type!: number;
    Content!: string;
    TypesClass = {
        0: 'errorMessage',
        1: "primaryMessage",
        2: "successMessage",
        3:"warningMessage"
    }
    constructor(private _snackBar: MatSnackBar) { }

    Show() {
        this._snackBar.open(this.Content, 'X', {
            duration: 5000,
            panelClass: [this.TypesClass[this.Type as keyof typeof this.TypesClass]]
        });
  }
  alertShow(content: string, type: number) {
    this.Content = content;
    this.Type = type;
    this.Show();
  }
}
